import React from 'react';
import Link from '../Link/Link';

const AboutAndHelp = () => (
  <div className="common-footer__about-and-help">
    <div className="common-footer__about">
      <h3>About Zola</h3>
      <ul className="about-and-help-links">
        <li>
          <Link href="/about/index" subtle>
            Our Story
          </Link>
        </li>
        <li>
          <Link href="/about/press" subtle>
            Press
          </Link>
        </li>
        <li>
          <Link href="/about/team" subtle>
            Jobs
          </Link>
        </li>
        <li>
          <Link href="/inspiration/become-a-vendor" subtle>
            Wedding Vendors
          </Link>
        </li>
        <li>
          <Link href="/wedding-registry/invite" subtle>
            Refer a Friend
          </Link>
        </li>
        <li>
          <Link href="/wedding-registry/couple-reviews" subtle>
            Zola Reviews
          </Link>
        </li>
      </ul>
    </div>
    <div className="common-footer__help">
      <h3>Help</h3>
      <ul className="about-and-help-links">
        <li>
          <Link href="/expert-advice" subtle>
            Expert Advice
          </Link>
        </li>
        <li>
          <Link href="/search/wedding-registry" subtle>
            Find a Couple on Zola
          </Link>
        </li>
        <li>
          <Link href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer" subtle>
            FAQs
          </Link>
        </li>
        <li>
          <Link href="/order-status" subtle>
            Track Order
          </Link>
        </li>
        <li>
          <Link href="/order-status" subtle>
            Start A Return
          </Link>
        </li>
        <li>
          <Link href="/returns" subtle>
            Return Policy
          </Link>
        </li>
        <li>
          <Link href="/contact-us" subtle>
            Contact Us
          </Link>
        </li>
      </ul>
    </div>
  </div>
);

export default AboutAndHelp;
